import service from '@/utils/request';
export var getAllFile = function getAllFile() {
  return service({
    url: '/operation/getAllFile',
    method: 'get'
  });
};